import type { CSSObject } from "@mui/material/styles";

/**
 * Shared focus ring styles for input components.
 * Uses CSS variables + ::before pseudo-element for animated focus ring.
 *
 * @param errorClass - The CSS class selector for the error state (differs per input component)
 * @param disabledClass - The CSS class selector for the disabled state
 */
export function getInputFocusRingStyles(
	errorClass: string,
	disabledClass: string
): CSSObject {
	return {
		"--Input-focused": 0,
		"--Input-focusedHighlight": "var(--mui-palette-primary-main)",
		"--Input-focusedThickness": "2px",
		"--Input-borderWidth": "1px",
		"--Input-borderColor": "var(--mui-palette-OutlinedInput-border)",
		"--Input-boxShadow": "var(--mui-shadows-1)",
		border: "var(--Input-borderWidth) solid var(--Input-borderColor)",
		boxShadow: "var(--Input-boxShadow)",
		"&::before": {
			borderRadius: "inherit",
			bottom: 0,
			boxShadow:
				"0 0 0 calc(var(--Input-focused) * var(--Input-focusedThickness)) var(--Input-focusedHighlight)",
			content: '" "',
			left: 0,
			pointerEvents: "none",
			position: "absolute",
			right: 0,
			top: 0,
		},
		"&:focus-within": { "&::before": { "--Input-focused": 1 } },
		"label + &": { marginTop: "8px" },
		[errorClass]: {
			"--Input-borderColor": "var(--mui-palette-error-main)",
			"--Input-focusedHighlight": "var(--mui-palette-error-main)",
		},
		[disabledClass]: { "--Input-boxShadow": "none" },
	} as CSSObject;
}
